import { Employee } from '../employee/employee.model';

export class PayrollFilterableEmployee extends Employee {
    protected static _resource = 'payroll/employees';
}
